import axios from "axios";

export default {
  get(paginationString) {
    if (paginationString) {
      return axios.get(`/api/statsContract${paginationString.text}`);
    } else {
      return axios.get("/api/statsContract");
    }
  },
  getByCustomerId(id) {
    return axios.get(`/api/statsContract/customer/${id}`);
  },
  getByCustomerAdmin(id) {
    return axios.get(`/api/statsContract/calculated/customer/${id}`);
  },
  getByContractId(contractId) {
    return axios.get(`/api/statsContract/calculated/contract/${contractId}`);
  },
  recalculatePoints(id) {
    return axios.post(`/api/statsContract/recalculate/${id}`);
  },
  recalculateHistoricalPoints(contractId, targetDate) {
    return axios.post(
      `/api/statsContract/recalculate-historical/${contractId}`,
      JSON.stringify(targetDate),
      {
        headers: {
          "Content-Type": "application/json",
        },
      },
    );
  },
  updatePoints(data) {
    return axios.post("api/statsContract/updatePoints", data);
  },
};
